module.exports = __webpack_public_path__ + "assets/images/Passport@2x.45ce2d94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Passport@2x.svg
// module id = 411
// module chunks = 1